import tmhRequest from '@/config/tmhRequest'

export default {

  searchOrderMonitorCount: function (data) {
    return tmhRequest({
      url: '/safe/ispa/ordermonitor/searchordermonitorcount',
      method: 'post',
      data: data,
    })
  },
  searchOrderMonitorByPage: function (data) {
    return tmhRequest({
      url: '/safe/ispa/ordermonitor/searchordermonitorbypage',
      method: 'post',
      data: data,
    })
  },

  dealTargetOrderSafeCheck: function ( data) {
    return tmhRequest({
      url: '/safe/ispa/ordermonitor/dealtargetordersafecheck',
      method: 'post',
      params: data,
    })
  },

  scanTargetDateOrder: function (data) {
    return tmhRequest({
      url: '/safe/easy/ordermonitor/scantargetdateorder',
      method: 'post',
      params: data,
    })
  },

  scanTargetOrder: function (data) {
    return tmhRequest({
      url: '/safe/easy/ordermonitor/scantargetorder',
      method: 'post',
      params: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/ispa/safe/ordermonitor.js